<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <!-- 工作台是全屏工作区，隐藏站点页脚与返回顶部，避免撑出页面滚动条 / 悬浮遮挡预览面板 -->
    <Footer v-if="!fullscreenPage"></Footer>
    <GoTop v-if="!fullscreenPage"></GoTop>
  </div>
</template>

<script>
/* 占满视口的全屏工作区路由（按路由 name 匹配，避免带参数/尾斜杠导致漏判）；
   文档中心页面同样隐藏页脚，保持阅读区沉浸式布局 */
const FULLSCREEN_ROUTES = ['Workbench', 'docCenter', 'docCenterDoc']

export default {
  name: 'App',
  computed: {
    fullscreenPage() {
      return FULLSCREEN_ROUTES.indexOf(this.$route && this.$route.name) > -1
    }
  },
  created() {
    if (localStorage.getItem('open-nickName')) {
      this.$store.state.login.isLogin = true
    }
    if (localStorage.getItem('open-userInfo') != '') {
      this.$store.state.login.userInfo = JSON.parse(localStorage.getItem('open-userInfo'))
    }

    // this.$store.state.login.userInfo = res.data.user
  },
}
</script>

<style>
::-webkit-scrollbar {
  display: none;
}

隐藏滚动条
.element {
  overflow: -moz-scrollbars-none;
  overflow: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

/* 滚动条样式 */
.element::-webkit-scrollbar {
  width: 0;
  height: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue